import { useState, useEffect } from "react";
import { href } from "react-router-dom";import { Link } from "react-router-dom";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const socialMediaLinks = [
        { id: "facebook", icon: "F", color: "bg-blue-600", url: "#" },
        { id: "twitter", icon: "X", color: "bg-black", url: "#" },
        { id: "linkedin", icon: "in", color: "bg-blue-700", url: "#" },
        { id: "instagram", icon: "IG", color: "bg-pink-600", url: "#" },
        { id: "youtube", icon: "YT", color: "bg-red-600", url: "#" },
    ];

    const navLinks = [
        {name:"Home", href: "/"},
        { 
            name: "Know Us", 
            href: "#",
            dropdown: [
                { name: "About Us", href: "/about" },
                {name: "History", href:"/journey"},
                { name: "Governing Body", href: "/governing-body" },
                { name: "Advisory Board", href: "/advisory" },
                { name: "Office Bearers", href: "/leadership" },
                { name: "International Cooperation", href: "/internationalCooperation" }
            ]
        },
        { name: "UN Partnership", href: "/partnership" },
        { name: "Services", href: "/services" },
        { name: "Newsletters", href: "/newsletter" },
        { name: "Events", href: "#" , 
            dropdown:[
                {name:"Upcoming Events" , href:"/upcomingEvents"},
                {name:"Events Reports", href:"/reports"}
            ]
        },
        { 
            name: "MSME Schemes", 
            href: "/msmeSchemes",
            dropdown: [
                {name:"MSME Schemes" , href:"/msmeSchemes"},
                { name: "Credit Linked Capital Subsidy", href: "#" },
                { name: "Prime Minister Employment Scheme", href: "#" },
                { name: "Stand-Up India Scheme", href: "#" },
                { name: "ZED Certification Scheme", href: "#" },
                { name: "Entrepreneurship Development", href: "#" }
            ]
        },
        { name: "ICSME", href: "/icsme" },
        { name: "Contact", href: "/contact" },
    ];

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle dropdown toggle
    const handleDropdownToggle = (linkName) => {
        setOpenDropdown(openDropdown === linkName ? null : linkName);
    };

    // Close mobile menu when clicking outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (isMobileMenuOpen && !event.target.closest('.mobile-menu-container')) {
    //             setIsMobileMenuOpen(false);
    //         }
    //     };
    //     document.addEventListener('click', handleClickOutside);
    //     return () => document.removeEventListener('click', handleClickOutside);
    // }, [isMobileMenuOpen]);

    return (
        <>
            {/* Top Blue Strip */}
            <div className="bg-[#1b73a7] text-white text-sm overflow-hidden">
                <div className="container mx-auto px-4 py-1">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
                        {/* Live Event Badge & Text */}
                        <div className="flex items-center space-x-3 w-full md:w-auto justify-center md:justify-start">
                            <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-blue-900 px-3 py-1 rounded-full text-xs font-bold animate-pulse shadow-lg">
                                <span className="flex items-center space-x-1">
                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                    </svg>
                                    <span>LIVE</span>
                                </span>
                            </div>
                            <div className="text-sm font-medium text-white/90 whitespace-nowrap overflow-hidden">
                                <div className="animate-marquee">
                                    MSME Growth Summit 2026 | 15th December | New Delhi
                                </div>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="flex flex-col sm:flex-row items-center space-y-1 sm:space-y-0 sm:space-x-6 text-xs md:text-sm">
                            <a
                                href="tel:+911234567890"
                                className="flex items-center space-x-2 hover:text-yellow-300 transition-colors duration-200"
                            >
                                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <span>+91-120-4216-283</span>
                            </a>

                            <a
                                href="mailto:contact@wasme.org"
                                className="flex items-center space-x-2 hover:text-yellow-300 transition-colors duration-200"
                            >
                                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                <span>contact@wasme.org</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <nav className={`bg-white border-b shadow-sm sticky top-0 z-40 transition-all duration-300 ${isScrolled ? 'shadow-lg' : 'shadow-sm'}`}>
                <div className="container mx-auto px-4 py-3">
                    <div className="flex items-center justify-between">
                        {/* Logo */}
                        <div className="flex items-center">
                            <img
                                src="/img/wasme_logo.png"
                                alt="WASME"
                                className="h-20 md:h-20 object-contain"
                            />
                        </div>

                        {/* Desktop Navigation */}
                        <div className="hidden lg:flex items-center space-x-6 ml-auto">
                            {navLinks.map((link) => (
                                <div key={link.name} className="relative group">
                                    {link.dropdown ? (
                                        <>
                                            <button
                                                onClick={() => handleDropdownToggle(link.name)}
                                                className="text-[#2b93d0] font-medium hover:text-[#d29431] transition-colors duration-200 flex items-center space-x-1"
                                            >
                                                <span>{link.name}</span>
                                                <svg 
                                                    className={`w-4 h-4 transition-transform duration-200 ${openDropdown === link.name ? 'rotate-180' : ''}`}
                                                    fill="none" 
                                                    stroke="currentColor" 
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </button>
                                            
                                            {/* Desktop Dropdown */}
                                            <div className={`absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-100 py-2 transition-all duration-300 transform origin-top ${openDropdown === link.name ? 'scale-100 opacity-100 visible' : 'scale-95 opacity-0 invisible'}`}>
                                                {link.dropdown.map((item) => (
                                                    <a
                                                        key={item.name}
                                                        href={item.href}
                                                        className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-[#2b93d0] transition-colors duration-200"
                                                    >
                                                        {item.name}
                                                    </a>
                                                ))}
                                            </div>
                                        </>
                                    ) : (
                                        <a
                                            href={link.href}
                                            className="text-[#2b93d0] font-medium hover:text-[#d29431] relative group/link transition-colors duration-200"
                                        >
                                            {link.name}
                                            <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#d29431] group-hover/link:w-full transition-all duration-300"></span>
                                        </a>
                                    )}
                                </div>
                            ))}

                            {/* Desktop CTA Buttons */}
                            <div className="flex items-center space-x-4 ml-6">
                              <Link to="/membership">
  <button className="bg-gradient-to-r from-[#2b93d0] to-[#1a7bb8] hover:from-[#1a7bb8] hover:to-[#2b93d0] text-white px-5 py-2.5 rounded-md font-semibold text-sm shadow hover:shadow-lg transition-all duration-300 whitespace-nowrap">
    Become a Member
  </button>
</Link>
                                <button className="bg-gradient-to-r from-[#2b93d0] to-[#1a7bb8] hover:from-[#1a7bb8] hover:to-[#2b93d0] text-white px-5 py-2.5 rounded-md font-semibold text-sm shadow hover:shadow-lg transition-all duration-300 whitespace-nowrap">
                                    News Portal
                                </button>
                            </div>
                        </div>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="lg:hidden flex flex-col space-y-1.5 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                            aria-label="Toggle menu"
                        >
                            <span className={`w-6 h-0.5 bg-[#2b93d0] transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                            <span className={`w-6 h-0.5 bg-[#2b93d0] transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                            <span className={`w-6 h-0.5 bg-[#2b93d0] transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu-container lg:hidden fixed inset-0 z-50 transition-all duration-500 ${isMobileMenuOpen ? 'visible' : 'invisible'}`}>
                    {/* Backdrop */}
                    <div 
                        className={`absolute inset-0 bg-black transition-opacity duration-500 ${isMobileMenuOpen ? 'opacity-50' : 'opacity-0'}`}
                        onClick={() => setIsMobileMenuOpen(false)}
                    ></div>
                    
                    {/* Mobile Menu Panel */}
                    <div className={`absolute right-0 top-0 h-full w-80 bg-white shadow-2xl transition-transform duration-500 ease-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                        <div className="p-6 h-full flex flex-col overflow-y-auto">
                            {/* Mobile Menu Header */}
                            <div className="flex items-center justify-between mb-8">
                                <img
                                    src="img/wasme_logo.png"
                                    alt="WASME"
                                    className="h-12 object-contain"
                                />
                                <button
                                    onClick={() => setIsMobileMenuOpen(false)}
                                    className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                                >
                                    <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            {/* Mobile Navigation Links */}
                            <div className="flex-1 space-y-2">
                                {navLinks.map((link) => (
                                    <div key={link.name} className="border-b border-gray-100">
                                        {link.dropdown ? (
                                            <div className="py-3">
                                                <button
                                                    onClick={() => handleDropdownToggle(link.name)}
                                                    className="flex items-center justify-between w-full text-left text-[#2b93d0] font-medium hover:text-[#d29431] transition-colors duration-200"
                                                >
                                                    <span>{link.name}</span>
                                                    <svg 
                                                        className={`w-5 h-5 transition-transform duration-200 ${openDropdown === link.name ? 'rotate-180' : ''}`}
                                                        fill="none" 
                                                        stroke="currentColor" 
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </button>
                                                
                                                {/* Mobile Dropdown */}
                                                <div className={`overflow-hidden transition-all duration-300 ${openDropdown === link.name ? 'max-h-96 opacity-100 mt-2' : 'max-h-0 opacity-0'}`}>
                                                    <div className="ml-4 space-y-1 pb-2">
                                                        {link.dropdown.map((item) => (
                                                            <a
                                                                key={item.name}
                                                                href={item.href}
                                                                className="block py-2 text-gray-600 hover:text-[#2b93d0] transition-colors duration-200 border-l-2 border-transparent hover:border-[#d29431] pl-3"
                                                                onClick={() => setIsMobileMenuOpen(false)}
                                                            >
                                                                {item.name}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <a
                                                href={link.href}
                                                className="block py-3 text-[#2b93d0] font-medium hover:text-[#d29431] transition-colors duration-200 border-l-4 border-transparent hover:border-[#d29431] pl-2"
                                                onClick={() => setIsMobileMenuOpen(false)}
                                            >
                                                {link.name}
                                            </a>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Mobile CTA Buttons */}
                            <div className="space-y-4 pt-6 border-t border-gray-200">
                                <button className="w-full bg-gradient-to-r from-[#2b93d0] to-[#1a7bb8] hover:from-[#1a7bb8] hover:to-[#2b93d0] text-white px-5 py-3 rounded-lg font-semibold text-sm shadow transition-all duration-300">
                                    Become a Member
                                </button>
                                <button className="w-full bg-gradient-to-r from-[#2b93d0] to-[#1a7bb8] hover:from-[#1a7bb8] hover:to-[#2b93d0] text-white px-5 py-3 rounded-lg font-semibold text-sm shadow transition-all duration-300">
                                    News Portal
                                </button>
                            </div>

                            {/* Mobile Social Icons */}
                            <div className="flex justify-center space-x-4 pt-8">
                                {socialMediaLinks.map((social) => (
                                    <a
                                        key={social.id}
                                        href={social.url}
                                        className={`w-10 h-10 rounded-full ${social.color} flex items-center justify-center text-white shadow hover:scale-110 transition-transform duration-200`}
                                    >
                                        <span className="font-bold text-sm">{social.icon}</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Sticky Social Icons (Desktop Only) */}
            <div className="hidden lg:flex fixed right-4 top-1/2 -translate-y-1/2 z-30 flex-col space-y-3">
                {socialMediaLinks.map((social) => (
                    <a
                        key={social.id}
                        href={social.url}
                        className={`w-10 h-10 rounded-full ${social.color} flex items-center justify-center text-white shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-xl`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="font-bold text-sm">{social.icon}</span>
                    </a>
                ))}
            </div>

            {/* Marquee Animation */}
            <style jsx>{`
                @keyframes marquee {
                    0% { transform: translateX(100%); }
                    100% { transform: translateX(-100%); }
                }
                .animate-marquee {
                    display: inline-block;
                    animation: marquee 20s linear infinite;
                    padding-left: 100%;
                    white-space: nowrap;
                }
                
                @media (max-width: 768px) {
                    .animate-marquee {
                        animation: marquee 15s linear infinite;
                    }
                }
            `}</style>
        </>
    );
};

export default Navbar;